import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type InputModal = {
	open: boolean
	screenshotImage: string | null
	errorInCapturingScreenshot: string | null
};

const initialState: { data: InputModal } = {
	data: {
		open: false,
		screenshotImage: null,
		errorInCapturingScreenshot: null
	}
};

export const debugDialogSlice = createSlice({
	name: 'debugDialogProvider',
	initialState,
	reducers: {
		toggleDebugDialogState(state, action: PayloadAction<{ value: boolean, screenshotImage?: string | null,
			errorInCapturingScreenshot?: string | null }>) {
			state.data.open = action.payload.value;
			state.data.screenshotImage = action.payload.screenshotImage || null;
			state.data.errorInCapturingScreenshot = action.payload.errorInCapturingScreenshot || null;
		}
	}
});

export const { toggleDebugDialogState } = debugDialogSlice.actions;

export default debugDialogSlice.reducer;